var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

pym.then(child => {
  var urlmenu = document.getElementById( 'state-drop' );
  var url = "https://www.npr.org/1098827190";

  urlmenu.onchange = function() {
    top.location = url + "#" + this.options[ this.selectedIndex ].value;
  };

    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
});
